<template>
	<div class="tpl send-tree-wrap">
		<mt-header title="发布树洞" fixed>
			<router-link :to="{name:'trends',query:{'selected':'3'}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button class="submitTreeHole"  icon="more" slot="right" @click.native="submitTreeHole">发布</mt-button>
		</mt-header>
		<div class="edit-box">
			<p>
				<input type="text" placeholder="标题" v-model="title"/>
			</p>
			<p>
				<textarea placeholder="内容" v-model="text"></textarea>
			</p>
			
			<div class="option-box">
				<span>是否开启评论</span>
				<mt-switch v-model="isComment"></mt-switch>
			</div>
			<div class="option-box">
				<span>是否允许私聊</span>
				<mt-switch v-model="isChat"></mt-switch>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"send-tree-hole",
		data(){
			return{
				uid:"",
				title:"",
				text:"",
				isComment:true,
				isChat:true
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","trends");
			this.$store.commit("changeTabBarShow",false);
		},
		methods:{
			submitTreeHole(){
				if(!this.isLogin()){return false;}
				let isComment = Number(this.isComment);
				let isChat = Number(this.isChat);
				console.log(isComment,isChat)
				this.$axios({
					url:"Dynamic/TreeHole",
					method:"post",
					data:{
						uid:this.uid,
						title:this.title,
						text:this.text,
						open_comment:isComment,
						anonymous_chat:isChat
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:"发布成功~",
							position:"bottom",
							duration:3000
						})
						this.$router.push({
							name:'trends',
							query:{'selected':'3'}
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.send-tree-wrap{
		padding-top: 2.5rem;
		background: #fff;
		min-height: 100vh;
	}
	>>>.mint-button-text{
		color:#282828;
	}
	.edit-box{
		padding: 0.5rem 1rem;
	}
	.edit-box p{
		padding: 0.3rem 0;
		border-bottom: 1px solid #f3f3f3;
	}
	.edit-box input{
		border: 0;
		outline: 0;
		background: none;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: bold;
		width: 100%;
	}
	.edit-box textarea{
		border: 0;
		outline: 0;
		background: none;
		font-size: 0.9rem;
		line-height: 1.5rem;
		width: 100%;
		height: 10rem;
	}
	.edit-box .option-box{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0;
		border-bottom: 1px solid #f3f3f3;
		font-size: 0.8rem;
		color: #282828;
	}
	>>>.mint-switch-core{
		width: 46px;
		height: 26px;
	}
	>>>.mint-switch-core::before{
		width: 24px;
		height: 24px;
	}
	>>>.mint-switch-core::after{
		width: 24px;
		height: 24px;
	}
	>>>.mint-switch-input:checked + .mint-switch-core{
		background: rgba(84,21,249,.3);
		border-color: transparent;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/SendTreeHole.vue